/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TOTPVerifyAttestationData
 */
export interface TOTPVerifyAttestationData {
    /**
     * 
     * @type {string}
     * @memberof TOTPVerifyAttestationData
     */
    otp?: string;
}

/**
 * Check if a given object implements the TOTPVerifyAttestationData interface.
 */
export function instanceOfTOTPVerifyAttestationData(value: object): value is TOTPVerifyAttestationData {
    return true;
}

export function TOTPVerifyAttestationDataFromJSON(json: any): TOTPVerifyAttestationData {
    return TOTPVerifyAttestationDataFromJSONTyped(json, false);
}

export function TOTPVerifyAttestationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TOTPVerifyAttestationData {
    if (json == null) {
        return json;
    }
    return {
        
        'otp': json['otp'] == null ? undefined : json['otp'],
    };
}

export function TOTPVerifyAttestationDataToJSON(json: any): TOTPVerifyAttestationData {
    return TOTPVerifyAttestationDataToJSONTyped(json, false);
}

export function TOTPVerifyAttestationDataToJSONTyped(value?: TOTPVerifyAttestationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'otp': value['otp'],
    };
}

